document.addEventListener('click', (event) => {
  const target = event.target;

  console.log(event);

  if (event.target.dataset.modalTarget) {
    modalPop(event);
  }

  if (event.target.hasAttribute('data-toggle-reset')) {
    // console.log('reset toggles');
    const toggles = document.querySelectorAll('[data-toggle-target]');
    const targets = document.querySelectorAll('[data-toggle-content]');
    toggles.forEach((toggle) => {
      toggle.classList.remove('active');
    });

    targets.forEach((toggle) => {
      toggle.classList.remove('active');

      setTimeout(function () {
        toggle.style.height = '0px';
      }, 500);
    });
  }


  if (target.hasAttribute('data-close-outside')) {
    const parent = target.closest('[data-toggle-content]');
    toggleTargetName = parent.dataset.toggleContent;
    parent.classList.remove('active');
    document
      .querySelector(`[data-toggle-target="${toggleTargetName}"]`)
      .classList.remove('active');
  }
});


function modalPop(event) {
  console.log(event);
  event.preventDefault();
  const target = event.target.dataset.modalTarget;
  const modalContent = document.querySelector(
    `[data-modal-content="${target}"]`
  );
  const closeModal = modalContent.querySelector('[data-close]');
  const modalSlider = modalContent.querySelector('.bd-slider');
  const modalVideo = modalContent.querySelectorAll('video');
  console.log('open modal');
  modalContent.classList.add('active');
  document.querySelector('body').classList.add('overflow-hidden');
  closeModal.onclick = function () {
    //  console.log('close modal');
    modalContent.classList.remove('active');
    document.querySelector('body').classList.remove('overflow-hidden');

    if (modalVideo) {
      modalVideo.forEach((video) => {
        video.pause();
      });
    }
  };

  window.onclick = function (event) {
    // console.log(event);
    if (event.target == modalContent) {
      // console.log('close modal');

      modalContent.classList.remove('active');
      document.querySelector('body').classList.remove('overflow-hidden');

      if (modalVideo) {
        modalVideo.forEach((video) => {
          video.pause();
        });
      }
    }
  };
  window.addEventListener('keyup', function (e) {
    if (e.code === 'Escape') {
      modalContent.classList.remove('active');
      document.querySelector('body').classList.remove('overflow-hidden');

      if (modalVideo) {
        modalVideo.forEach((video) => {
          video.pause();
        });
      }
    }
  });

  if (modalSlider) {
    const slider = new slick(modalSlider);
    console.log('resize slider');
    slider.resize();
  }
}